// extracted by mini-css-extract-plugin
export default {"main":"src_main__eVsfQ"};